import { useRouter } from 'next/router';

import { useIntl } from '@klokhuis/core/Intl';
import { ROUTES } from '@klokhuis/core/Routing';
import { useMediaIsDesktop } from '@klokhuis/utilities/Media/useMediaIsDesktop';

import styles from './Header.module.css';
import { HeaderDesktop } from './HeaderDesktop';
import { HeaderMobile } from './HeaderMobile';

export interface HeaderProps {
  isBigHeader: boolean;
}

export const Header = ({ isBigHeader }: HeaderProps) => {
  const isDesktop = useMediaIsDesktop();
  const router = useRouter();
  const { locale } = useIntl();
  const isHomePage = router.asPath === ROUTES.Home.url({});
  return (
    <header
      id="page-header"
      data-testid="PageHeader"
      className={isBigHeader ? styles.rootInnerPage : styles.root}
    >
      {isDesktop ? <HeaderDesktop /> : <HeaderMobile />}
    </header>
  );
};
